import { Button, CheckmarkCircleFilledIcon } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'

import { useMobile } from '@/hooks'
import { NewHomeIssue } from '@/types/HomeIssue'
import { formattedDatetime } from '@/views/Home/Home/HomeQualityChecks/HomeIssues/HomeIssue.data'

type Props = {
  homeIssue: NewHomeIssue
  toggle: () => void
}

export const ReportIssueConfirmation = ({ homeIssue, toggle }: Props) => {
  const createdAt = formattedDatetime(homeIssue.createdAt)
  const { isTablet } = useMobile()

  return (
    <ConfirmationStyled className="flex w-full flex-col flex-wrap px-6">
      <h2 className="mb-6 text-header-lg leading-120">Your issue has been reported!</h2>
      <p className=" mb-6 flex items-center rounded-2xl px-6 py-4 text-white bg-accent-dark">
        <CheckmarkCircleFilledIcon className="mr-4 h-4 text-black" />{' '}
        <span className="leading-none">Home Issue ID: {homeIssue.id}</span>
      </p>
      <div className="home-issue-line-item">
        <p>Location</p>
        <p className="font-bold">{homeIssue.homeLocation}</p>
      </div>

      <div className="home-issue-line-item">
        <p>Type</p>
        <p className="font-bold">{homeIssue.type}</p>
      </div>

      {homeIssue.homeInventoryItem?.name && (
        <div className="home-issue-line-item">
          <p>Inventory Item</p>
          <p className="font-bold">{homeIssue.homeInventoryItem.name}</p>
        </div>
      )}

      <div className="home-issue-line-item">
        <p>Created At</p>
        <p>{createdAt}</p>
      </div>

      {homeIssue.notes && (
        <div className="mb-4 flex w-full flex-col py-4">
          <p className="mb-2 font-bold leading-120 text-icon-tertiary">Notes</p>
          <p>{homeIssue.notes}</p>
        </div>
      )}
      <div className="flex flex-col-reverse justify-between md:flex-row">
        <Button
          className="w-full bg-action-secondary md:flex md:w-auto"
          onClick={toggle}
          size={isTablet ? 'medium' : 'small'}
          variant="secondary"
        >
          Close
        </Button>
      </div>
    </ConfirmationStyled>
  )
}

export const ConfirmationStyled = styled.div`
  .home-issue-line-item {
    display: flex;
    height: 3.5rem;
    width: 100%;
    justify-content: space-between;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    overflow: hidden;
    border-bottom-width: 1px;
    border-color: #e7e6e4;
    margin-bottom: 0.25rem;
    p {
      &:first-of-type {
        line-height: 1.2;
        color: #787573;
        display: flex;
        align-items: center;
      }

      &:last-of-type {
        max-width: 50%;
        text-align: right;
        display: flex;
        align-items: center;
      }
    }
  }

  .font-bold {
    font-weight: 700;
  }
`
